import { IFormattingSettings } from '@fulcrum/lib';
import { CoordinateSettings } from './coordinate-settings.types';
import { SlopeMeasurementSettings } from './slope-measurement-settings.types';

type WithRequired<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

const requiredFormattingKeys = [
  'unitSystem',
  'lengthUnit',
  'lengthFormatting',
  'lengthMeasurementUnit',
  'lengthMeasurementFormatting',
] as const;

type RequiredFormattingKeys = (typeof requiredFormattingKeys)[number];

// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface FormattingSettings
  extends WithRequired<IFormattingSettings, RequiredFormattingKeys> {}

export interface ExtendedFormattingSettings extends FormattingSettings {
  coordinateOrder?: CoordinateSettings;
  slopeMeasurementSettings?: SlopeMeasurementSettings;
}

export interface FormattingSettingsResponse extends ExtendedFormattingSettings {
  isDefault: boolean;
}

export interface FormattingSettingsValidationResult {
  settings?: FormattingSettings;
  isInvalidUnitSystem?: boolean;
  hasInvalidUnits?: boolean;
}

export function isFormattingSettings(
  value?: IFormattingSettings
): value is FormattingSettings {
  if (!value) return false;

  return requiredFormattingKeys.every(
    (key) => value[key] !== undefined && value[key] !== null
  );
}

export interface FormattingSettingsOptions {
  enableCustomSystem?: boolean;
  enableUnitSystemSelection?: boolean;
  enableUnitSelection?: boolean;
  enablePrecisionSelection?: boolean;
  enableDescriptions?: boolean;
}
